
import { defineComponent, reactive, toRefs, watchEffect, onMounted } from 'vue'
import CImgView from '@/components/c-img-view'
import { toResult } from '@/utils/toResult'
import { getFileUrls } from './api'
// import { ElMessage } from 'element-plus'
// import { toResult } from '@/utils/toResult'

export default defineComponent({
  components: { CImgView },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
      default: false,
    },
    row: {
      type: Object,
      default: () => {},
    },
  },
  // emits: ['update:modelValue'],
  setup(props, { emit }) {
    const data = reactive({
      visible: false,
      titlename: '查看图片',
      srcList: [],
    })

    watchEffect(() => {
      data.visible = props.modelValue
    })

    /**
     * @description: 关闭dialog
     * @param {*} void
     * @return {*}
     */
    const onCancel = (): void => {
      data.visible = false
      emit('update:modelValue', false)
    }
    const convertImageStringToArray = (imageString) => {
      // 1. 处理无效输入 (null, undefined, 非字符串) 或空字符串
      if (!imageString || typeof imageString !== 'string') {
        return [] // 返回空数组
      }

      // 2. 使用逗号分割字符串
      const filenamesArray = imageString.split(',')

      // 3. 处理每个元素：去除空格并过滤空值
      const cleanedFilenames = filenamesArray
        .map((filename) => filename.trim()) // 去除每个文件名前后的空格
        .filter((filename) => filename !== '') // 移除分割后可能产生的空字符串

      return cleanedFilenames
    }
    const init = async () => {
      if (props.row.imgs === null) {
        return
      }
      const resultArray = convertImageStringToArray(props.row.imgs)
      const params = {
        filenames: resultArray,
      }
      const [err, res] = await toResult(getFileUrls(params))
      if (err) return
      data.srcList = res.map((item) => item.url)
    }
    onMounted(() => {
      console.log(props.row.imgs)
      init()
    })
    return {
      ...toRefs(data),
      init,
      convertImageStringToArray,
      onCancel,
    }
  },
})
